import styled from '@emotion/styled';
import { theme } from '@ublend-npm/aulaui-next';

export const IframeWrapper = styled.div<{ isSelected?: boolean }>`
  display: inline-block;
  position: relative;
  margin-top: ${theme.spacing.xxSmall};
  border-radius: ${theme.borderRadius.medium};
  background-color: ${theme.color.designSystem.grey20};
  border: ${({ isSelected }) =>
    isSelected
      ? `1px solid ${theme.color.designSystem.purple70}`
      : `1px solid transparent`};
  width: 376px;

  // This so to make the iframe responsive (inspiration: https://stackoverflow.com/a/50013413/3350692)
  // Not all iframes are responsive by default (as the one from youtube)
  &::before {
    display: block;
    content: '';
    padding-top: 56.25%;
  }

  iframe {
    display: block;
    border-radius: ${theme.borderRadius.medium};
    overflow: hidden;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
`;
